<template>
  <section class="section" style="margin-bottom: 32px">
    <div class="table__buttons">
      <transition name="fade">
        <AppButtonSmRemove style="margin-right: 20px"
                           title="Удалить"
                           @click.native="deleteSelectedFuels"
                           v-show="fuelsHeader.isActiveDelete"
        />
      </transition>

      <AppButtonSmAdd title="Добавить"
                      @click.native="openFuelsModal"
      />
    </div>

    <div class="page__row">
      <AppTable title="Используемое топливо"
                v-if="transportFuels.length"
                :data="transportFuels"
                :headers="fuelsHeader.headers"
                has-checkbox
                is-special
                :all-items-active="fuelsHeader.allActive"
                @toggle-active-all="toggleAllActiveItemsSelectedFuel"
                @toggle-active-item="toggleSingleActiveItemSelectedFuel"
                @edit-this-item="openConsModal"
                @show-this-item="openConsModal"
      />

      <AppNoRecordsPlaceholder v-else />
    </div>

    <transition name="fade">
      <LogisticTransportUpdateFuelModal v-if="fuelsModal.active"
                                        @click.native="closeFuelsModal"
                                        @close-modal="closeFuelsModal"
                                        title="Добавить новое топливо"
      >
        <template v-slot:workersModalBody>
          <AppTable
            :data="fuels"
            :state="fuelsModal"
            :headers="fuelsModalHeader.headers"
            :all-items-active="fuelsModalHeader.allActive"
            has-checkbox
            is-special
            @toggle-active-all="toggleAllActiveItemsFuels"
            @toggle-active-item="toggleSingleActiveItemFuel"
          />

        </template>

        <template v-slot:workersModalFooter>
          <div class="modal__button-wrap">
            <div class="modal__button">
              <AppButton title="Добавить" type="main" @click.native="addFuels" />
            </div>

            <div class="modal__button">
              <AppButton title="Отмена" type="alt" @click.native="closeFuelsModal" />
            </div>
          </div>
        </template>
      </LogisticTransportUpdateFuelModal>

      <LogisticTransportUpdateFuelModal v-if="consModal.active"
                                        :title="`Норма расхода ${consModal.name} на 100 км.`"
                                        @click.native="closeConsModal"
                                        @close-modal="closeConsModal"
                                        height="auto"
                                        max-width="410px"
                                        footerCenter
      >
        <template v-slot:workersModalBody>
          <AppInput
            class="mb-20"
            title="Летом"
            :value="consModal.values.consumptionSummer"
            @value-changed="setFuelConsSummer"
          />

          <AppInput
            title="Зимой"
            :value="consModal.values.consumptionWinter"
            @value-changed="setFuelConsWinter"
          />
        </template>

        <template v-slot:workersModalFooter>
          <div class="form__buttons">
            <AppButton
              title="Сохранить"
              type="main"
              @click.native="setFuelCons"
            />

            <AppButton
              title="Отмена"
              type="alt"
              @click.native="closeConsModal"
            />
          </div>
        </template>
      </LogisticTransportUpdateFuelModal>
    </transition>
  </section>
</template>

<script>
import AppTable from '@/components/page/table/AppTable'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import LogisticTransportUpdateFuelModal from '@/components/logistic/LogisticTransportUpdateFuelModal'
import AppButton from '@/components/page/button/AppButton'
import AppInput from '@/components/page/input/AppInput'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'LogisticTransportUpdate_fuel',
  components: {
    AppNoRecordsPlaceholder,
    AppButtonSmRemove,
    AppInput,
    AppButton,
    LogisticTransportUpdateFuelModal,
    AppButtonSmAdd,
    AppTable
  },
  computed: {
    ...mapState('logistic/transportUpdate', {
      fuelsHeader: 'fuelsHeader',
      fuelsModal: 'fuelsModal',
      fuelsModalHeader: 'fuelsModalHeader',
      consModal: 'consumptionModal'
    }),
    ...mapGetters('logistic/transportUpdate', {
      fuels: 'getTransportItemFuels',
      transportFuels: 'getTransportItemAddedFuels'
    })
  },
  methods: {
    ...mapMutations('logistic/transportUpdate', {
      openFuelsModal: 'OPEN_TRANSPORT_ITEM_FUELS_MODAL',
      closeFuelsModal: 'CLOSE_TRANSPORT_ITEM_FUELS_MODAL',
      toggleAllActiveItemsFuels: 'TOGGLE_TRANSPORT_ITEM_CHECK_ALL_FUELS',
      toggleSingleActiveItemFuel: 'TOGGLE_TRANSPORT_ITEM_MODAL_CHECK_SINGLE_FUEL',
      openConsModal: 'OPEN_TRANSPORT_ITEM_CONS_MODAL',
      closeConsModal: 'CLOSE_TRANSPORT_ITEM_CONS_MODAL',
      setValueFuelCons: 'SET_FUEL_ITEM_FUEL_CONS_VALUE',
      setFuelConsSummer: 'SET_FUEL_ITEM_FUEL_CONS_SUMMER',
      setFuelConsWinter: 'SET_FUEL_ITEM_FUEL_CONS_WINTER',
      toggleAllActiveItemsSelectedFuel: 'TOGGLE_TRANSPORT_ITEM_CHECK_ALL_SELECTED_FUELS',
      toggleSingleActiveItemSelectedFuel: 'TOGGLE_TRANSPORT_ITEM_CHECK_SINGLE_SELECTED_FUEL',
      deleteSelectedFuels: 'DELETE_TRANSPORT_ITEM_SELECTED_CHECKED_FUELS'
    }),

    ...mapActions('logistic/transportUpdate', {
      setFuelCons: 'addTransportItemFuelCons',
      addFuels: 'addTransportItemSelectedFuels'
    })
  }

}
</script>
